module.exports = __webpack_public_path__ + "img/haidai.3192ca7f.jpg";